import React from 'react';

export const Upcoming = React.lazy(() => import('./Upcoming'));
export const Stream = React.lazy(() => import('./Stream/Stream'));
export const Archive = React.lazy(() => import('./Archive/Archive'));
export const StaffSelectionUpdates = React.lazy(() => import('./StaffSelections/StaffSelectionUpdates'));
export const MetartIntimateUpdates = React.lazy(() =>
  import('./MetartIntimate/MetartIntimateUpdates').then((m) => ({ default: m.MetartIntimateUpdates })),
);
